module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projectsgallery bg-light"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "header h4 light"
  }, [_c('span', {
    staticClass: "upcase medium"
  }, [_vm._v(_vm._s(_vm.configurator === "k1_wall" ? "k1" : _vm.configurator))]), _vm._v(" Gallery\n\n        "), _c('button', {
    staticClass: "header_close",
    on: {
      "click": _vm.emitClose
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "header h4 light"
  }, [_c('span', {
    staticClass: "upcase medium"
  }, [_vm._v(_vm._s(_vm.configurator === "k1_wall" ? "k1" : _vm.configurator))]), _vm._v(" projects\n        "), _c('div', {
    staticClass: "header_search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search medium h7 c-accent upcase",
    on: {
      "click": _vm.get_search
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "search medium h7 c-dgrey upcase",
    on: {
      "click": _vm.filterObjects
    }
  }, [_vm._v("View all")])]), _vm._v(" "), _c('button', {
    staticClass: "header_close",
    on: {
      "click": _vm.emitClose
    }
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.projects) ? _c('div', {
    staticClass: "loading c-dark h4 light"
  }, [_c('miniloader')], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.projects) ? _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      staticClass: "project_element"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img.onload.start",
        value: (_vm.onloadstart),
        expression: "onloadstart",
        modifiers: {
          "onload": true,
          "start": true
        }
      }, {
        name: "img",
        rawName: "v-img.onload.finish",
        value: (_vm.onloadfinish),
        expression: "onloadfinish",
        modifiers: {
          "onload": true,
          "finish": true
        }
      }],
      attrs: {
        "src": project.image.standard.url
      },
      on: {
        "click": function($event) {
          _vm.injectProject($event, project)
        }
      }
    }), _vm._v(" "), _c('span', [(_vm.loggedIn) ? _c('div', {
      staticClass: "upcase h11"
    }, [_vm._v(_vm._s(project.title) + " - " + _vm._s(project.client_name))]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
      staticClass: "upcase medium h11 c-accent",
      on: {
        "click": function($event) {
          _vm.deleteProject(project)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('delete')))]) : _vm._e()])])
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518d1688"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/ProjectsGallery.vue
// module id = 633
// module chunks = 0